import React from 'react';
import { Tooltip, Toggle, ButtonBase, Pill, Text } from '@fullstory/components';
import { CompleteSessionsTooltip } from '../SessionConstraintsSelect';
import { intl } from '@fullstory/intl';
import { useFlags } from '@fullstory/react-hooks';
import { FormattedMessage } from 'react-intl';

interface SessionReplayCompleteSessionsFilterProps
  extends Pick<React.ComponentProps<typeof Tooltip>, 'placement' | 'variant'> {
  completeSessions: boolean;
  setCompleteSessions: (v: boolean) => void;
}

export const SessionReplayCompleteSessionsFilter = ({
  completeSessions,
  setCompleteSessions,
  variant = 'light',
  placement = 'left',
}: SessionReplayCompleteSessionsFilterProps) => {
  const newFSTAColors = useFlags().featureFlags().AppNewFstaColors;
  const useNewSessionPlaylist = useFlags().featureFlags().AppNewSessionPlaylistUi;
  return (
    <Tooltip
      variant={variant}
      placement={placement}
      tooltipContent={CompleteSessionsTooltip(completeSessions, 'playlist')}
    >
      {useNewSessionPlaylist ? (
        <Toggle
          testId="online-sessions-button"
          checked={!completeSessions}
          onToggle={() => setCompleteSessions(!completeSessions)}
          label={{
            text: intl.formatMessage({ defaultMessage: 'Include Live Sessions', id: 'iJnWcB' }),
            appearance: 'bodyXSmall',
          }}
          labelPosition="right"
          alignItems="flex-end"
        />
      ) : (
        <ButtonBase
          testId="online-sessions-button"
          onClick={_ => setCompleteSessions(!completeSessions)}
        >
          <Pill
            variant="primary"
            color={completeSessions ? 'disabled' : newFSTAColors ? 'brand-green' : 'green-base'}
            noExternalSpacing
          >
            <Text appearance="bodySmall" color="default-inverse">
              <FormattedMessage defaultMessage="Online" id="ccU6l/" />
            </Text>
          </Pill>
        </ButtonBase>
      )}
    </Tooltip>
  );
};
